import { useEffect } from "react";

const DEFAULT_DESCRIPTION =
  "Paramount Kitchen designs and manufactures premium modular kitchens in Kangra District, Himachal Pradesh — engineered carcass construction, hydraulic cold-pressed plywood and premium hardware.";

export const SEO = ({ title, description }) => {
  useEffect(() => {
    if (title) document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    if (meta && description) meta.setAttribute("content", description);
  }, [title, description]);
  return null;
};
